import React, { useState } from 'react';
import axios from 'axios';

const AddCoupon = ({ onCouponAdded = () => {} }) => {
  const [formData, setFormData] = useState({
    code: '',
    discountType: 'percentage',
    discountAmount: '',
    expiryDate: '',
    minOrderAmount: '',
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    code: formData.code,
    discountType: formData.discountType, // 'percentage' or 'flat'
    discountValue: Number(formData.discountAmount),
    minOrderAmount: Number(formData.minOrderAmount),
    maxDiscount: Number(formData.maxDiscount || 0), // optional
     expiresAt: new Date(formData.expiryDate), 
  };

  try {
    await axios.post('https://api.taratoys.in/api/coupons', payload);
    alert('Coupon created!');
    setFormData({
      code: '',
      discountType: 'percentage',
      discountAmount: '',
      minOrderAmount: '',
      maxDiscount: '',
      expiryDate: '',
    });
    onCouponAdded();
  } catch (error) {
    console.error('Error adding coupon:', error.response?.data || error.message);
    alert('Failed to create coupon.');
  }
};


  return (
    <div className="card mb-4 p-4">
      <h4>Create Coupon</h4>
      <form onSubmit={handleSubmit}>
        <input name="code" placeholder="Code" value={formData.code} onChange={handleChange} className="form-control mb-2" required />
        <select name="discountType" value={formData.discountType} onChange={handleChange} className="form-control mb-2">
          <option value="percentage">Percentage</option>
          <option value="fixed">Fixed Amount</option>
        </select>
        <input name="discountAmount" placeholder="Discount" type="number" value={formData.discountAmount} onChange={handleChange} className="form-control mb-2" required />
        <input
  name="maxDiscount"
  placeholder="Max Discount (Optional)"
  type="number"
  value={formData.maxDiscount}
  onChange={handleChange}
  className="form-control mb-2"
/>

        <input name="minOrderAmount" placeholder="Min Order Amount" type="number" value={formData.minOrderAmount} onChange={handleChange} className="form-control mb-2" />
        <input name="expiryDate" type="date" value={formData.expiryDate} onChange={handleChange} className="form-control mb-2" required />
        <button className="btn btn-primary">Add Coupon</button>
      </form>
    </div>
  );
};

export default AddCoupon;
